import styled from 'styled-components';
import media from 'styled-media-query';
import { MDBContainer } from 'mdbreact';

import { Divider as DefaultDivider } from 'components/FormGroup/Divider/styles';
import { Text } from 'components/DescriptionText/styles';

import colors from 'themes/Main';

const { gray05, danger } = colors;

export const Container = styled(MDBContainer)`
  margin: 0 auto;
  max-width: calc(100% - 224px) !important;

  ${media.lessThan('medium')`
    max-width: 100% !important;
  `}
`;

export const Introduction = styled.div`
  margin-top: 50px;
`;

export const DescriptionText = styled(Text)`
  text-transform: uppercase;
`;

export const Divider = styled(DefaultDivider)`
  margin-top: 32px;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${gray05};
  }
`;

export const Form = styled.form``;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CoordinatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 16px;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 4px;

  > button {
    margin: 16px 0 32px;
  }
`;

export const CoordinatorBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin: 16px 0;
  border-radius: 4px;

  &.error {
    border: 1px solid ${danger};
    border-bottom: 1px solid ${danger};
  }

  &:not(.error) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

export const RemoveCoordinator = styled.button.attrs({
  type: 'button',
})`
  align-self: flex-end;
  width: fit-content;
  margin-top: 16px;
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 14px;
  color: ${danger};
  transition: opacity 0.3s ease-in-out;

  svg {
    margin-right: 8px;
  }

  &:hover {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.3;
  }
`;

export const Buttons = styled.div`
  margin: 32px 0;

  button:nth-child(2) {
    margin-left: 16px;
  }
`;
